<!--
 * @Description: 整数输入框   这个以后改两组  一个是0-100  一个是这个样0-999 用于区分不同的类型
-->
<template>
  <config-item :label='label'>
    <el-slider
      v-model="mValue"
      v-bind="mOptions"
      show-input
    >
    </el-slider>
  </config-item>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";

export default {
  name: "SchemaNumber",

  mixins: [schemaMixin],

  data() {
    return {
      defaultOptions: {
        max: 998,
      },
    };
  },
};
</script>